import { Separator } from "@/components/ui/separator";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="bg-on-light">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="font-bold text-lg mb-4 text-on-dark">Dnceclub</h3>
            <p className="text-sm text-on-dark-muted">
              Dance studio management and pop-up classes, all in one place.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-3 text-on-dark">For Studios</h4>
            <ul className="space-y-2 text-sm text-on-dark-muted">
              <li>
                <Link
                  to="/join"
                  className="transition-colors"
                >
                  List Your Studio
                </Link>
              </li>
              <li>
                <Link
                  to="/fees"
                  className="transition-colors"
                >
                  Platform Fees
                </Link>
              </li>
              <li>
                <Link
                  to="/how-it-works"
                  className="transition-colors"
                >
                  How It Works
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-3 text-on-dark">For Renters</h4>
            <ul className="space-y-2 text-sm text-on-dark-muted">
              <li>
                <Link
                  to="/studios"
                  className="transition-colors"
                >
                  Browse Studios
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="transition-colors"
                >
                  FAQ
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="transition-colors"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-3 text-on-dark">Legal</h4>
            <ul className="space-y-2 text-sm text-on-dark-muted">
              <li>
                <Link
                  to="/privacy"
                  className="transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="my-8" />

        <div className="text-center text-sm text-on-dark-muted">
          © {new Date().getFullYear()} Dnceclub. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
